//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import { useListableProperties } from '@/api/legacy/useListableProperties';
import FilterEditor from '@/components/partials/Editors/FilterEditor.vue';
import OnlinePropertyEditor from '@/components/partials/Editors/OnlinePropertyEditor.ts.vue';
import { sxsOps, ops as thresholds } from '@/components/partials/FilterBuilder/helpers';
import Security from '@/config/security';
import { ops } from '@/kpi/constants';
import Convert from '@/mixins/convert'; // tmw_used
import Readable, { readableFilter, readableToHtml } from '@/mixins/readable';
import { FILTERS, MONITORS } from '@/store/types/namespaces';
import DpOption from './Option.vue';
import DpOptionGroup from './OptionGroup.vue';
import DpSelect from './Select.vue';

const NO_FILTER = () => true;

export default {
  name: 'DpPopulatedSelect',
  components: {
    DpSelect,
    DpOption,
    DpOptionGroup,
    FilterEditor,
    OnlinePropertyEditor,
  },
  mixins: [Convert, Readable],
  props: {
    allowed: { type: Array, required: true, default: () => [] },
    size: { type: String, required: false, default: '' },
    value: { type: [Object, String], default: () => null },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    hidden: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    showFilterManageButtons: { type: Boolean, default: false },
    editableFilters: { type: Boolean, default: false },
    disableTimeFilters: { type: Boolean, default: false },
    disableSxsOps: { type: Boolean, default: false },
    disableCalculatedProperties: { type: Boolean, default: false },
    disableOnlineProperties: { type: Boolean, default: false },
    tooltip: { type: String, default: null },
    propertyFilterFn: { type: Function, default: () => NO_FILTER },
  },
  setup() {
    const { listableProperties } = useListableProperties();
    return { listableProperties };
  },
  data() {
    return {
      editing: null,
      isCreatingNewFilter: false,
      isEditing: false,
      currentValue: this.value,
      Security,
      binSizes: [
        { label: '5 minute', val: '5m' },
        { label: '15 minutes', val: '15m' },
        { label: '30 minutes', val: '30m' },
        { label: '1 hour', val: '1h' },
        { label: '3 hours', val: '3h' },
        { label: '6 hours', val: '6h' },
        { label: '12 hours', val: '12h' },
        { label: '1 day', val: '1d' },
        { label: '3 days', val: '3d' },
        { label: '1 week', val: '1w' },
        { label: '2 weeks', val: '2w' },
        { label: '4 weeks', val: '4w' },
        { label: '1 month', val: '1M' },
      ],
    };
  },
  computed: {
    ...mapState(FILTERS, ['filters', 'filtersFetched']),
    ...mapGetters(MONITORS, ['monitors']),
    ...mapGetters([
      'kpis',
    ]),
    allowProperties() {
      return this.allowed.includes('properties');
    },
    allowTimestamps() {
      return this.allowed.includes('timestamps');
    },
    allowFilters() {
      return this.allowed.includes('filters');
    },
    allowOperations() {
      return this.allowed.includes('operations');
    },
    allowThresholds() {
      return this.allowed.includes('thresholds');
    },
    allowSxsThresholds() {
      return this.allowed.includes('sxsThresholds');
    },
    allowKpis() {
      return this.allowed.includes('kpis');
    },
    allowBins() {
      return this.allowed.includes('bins');
    },
    allowMonitors() {
      return this.allowed.includes('monitors');
    },
    isLoading() {
      if (this.allowFilters && !this.filtersFetched) {
        return true;
      }
      return false;
    },
    placeholderText() {
      if (this.placeholder) {
        return this.placeholder;
      }
      if (this.allowProperties && this.allowFilters) {
        return this.$t('ui.chooseOption');
      } if (this.allowProperties) {
        return this.$t('ui.choosePropertyOption');
      } if (this.allowFilters) {
        return this.$t('ui.chooseFilterOption');
      }
      return null;
    },
    filteredProperties() {
      // Check if this property has been hidden
      return this.listableProperties
        .filter(({ isCalculated, isOnline }) => {
          if (this.disableCalculatedProperties && isCalculated) return false;
          return !isOnline;
        })
        .filter((p) => {
          if (!this.hidden) {
            return true;
          }

          const hiddenMatch = this.hidden.find((h) => h === p || h?.name === p.name);
          return !hiddenMatch;
        })
        .filter(this.propertyFilterFn);
    },
    showTimestamps() {
      return this.allowProperties && !this.disableOnlineProperties;
    },
    filteredTimestamps() {
      if (!this.allowProperties) return [];
      if (this.disableOnlineProperties && !this.allowTimestamps) return [];
      return this.listableProperties
        .filter(({ isTs, isOnline }) => {
          if (this.disableOnlineProperties && this.isOnline) return false;
          if (!this.allowTimestamps && isTs) return false;
          return isTs || isOnline;
        })
        .filter((p) => {
          if (!this.hidden) {
            return true;
          }

          const hiddenMatch = this.hidden.find((h) => h === p || h?.name === p.name);
          return !hiddenMatch;
        });
    },
    filteredFilters() {
      if (!this.filters) return [];

      // Check if this filter has been hidden
      return this.filters.filter((f) => {
        if (!this.hidden) {
          return true;
        }

        let found = false;
        this.hidden.forEach((h) => {
          if (_.isEqual(h, f)) {
            found = true;
          }
        });

        return !found;
      }).map((f) => ({
        ...f,
        $tooltip: `<p style="text-align:left; margin: 0;">
          ${readableToHtml(readableFilter(f.expression, this.listableProperties))}</p>`,
      }));
    },
    filteredOperations() {
      return ops;
    },
    filteredThresholds() {
      if (!this.hidden) {
        return Object.values(thresholds);
      }

      return Object.values(thresholds)
        .filter((threshold) => !(this.hidden || [])
          .some((hidden) => hidden.value === threshold.value));
    },
    filteredSxsThresholds() {
      if (!this.hidden) {
        return Object.values(sxsOps);
      }

      return Object.values(sxsOps)
        .filter((threshold) => !(this.hidden || [])
          .some((hidden) => hidden.value === threshold.value))
        .map((sxsOp) => {
          if (this.disableSxsOps) {
            return { ...sxsOp, disabled: true };
          }
          return sxsOp;
        });
    },
    filteredKpis() {
      return this.kpis;
    },
    filteredMonitors() {
      return this.monitors;
    },
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
  },
  methods: {
    isTimeBased(filter) {
      return filter.expression.indexOf('ago') > -1;
    },
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    createOnlineProperty() {
      if (this.$refs.onlinePropertyEditor) {
        this.$refs.onlinePropertyEditor.open();
      }
    },
    saveOnlineProperty(name) {
      const property = this.convertPropertyNameToProperty(name);
      this.setCurrentValue(property);
      this.$emit('input', property);
      this.$emit('change', property);
    },
    createFilter() {
      this.editing = null;
      this.isEditing = true;
      this.$refs.select.hide();

      // Wait for the component to be added
      this.$nextTick(() => {
        if (this.$refs.filterEditor) {
          this.$refs.filterEditor.createNew();
        }
      });
    },
    canEditFilter(filter) {
      return this.editableFilters
        && Security.canWrite('filters')
        && !(this.disableTimeFilters && this.isTimeBased(filter));
    },
    editFilter(filterId) {
      this.$refs.select.hide();
      this.editing = filterId;
      this.isEditing = true;
    },
    closeEditFilter() {
      this.editing = null;
      this.isEditing = false;
    },
    gotoManage(page) {
      if (page === 'filters') {
        this.$router.push({ name: 'manageFilters' }).catch(() => {});
      }
    },
    getPropertyIcon(property) {
      if (property.isCalculated) return 'calculator';
      return property.metadata ? 'tag' : 'telemetry';
    },
    clear() {
      this.setCurrentValue(null);
    },
    saveEditFilter(filterId) {
      const modifiedFilter = this.convertFilterIdToFilter(filterId);
      this.setCurrentValue(modifiedFilter);
      this.$emit('input', modifiedFilter);
      this.$emit('change', modifiedFilter);
    },
    handleInput(newVal) {
      const value = newVal;
      this.$emit('input', value);
      this.setCurrentValue(value);
    },
    handleChange(newVal) {
      this.$emit('change', newVal);
    },
  },
};
